module.exports = __webpack_public_path__ + "fonts/firacode-medium.65168ed.woff2";